<template>
  <div class="container">
    <el-card class="mb5">
      <el-form
        ref="searchForm" v-model="queryForm" :inline="false"
        label-position="top"
      >
        <el-row :gutter="20">
          <el-col :span="6">
            <!--创建时间-->
            <el-form-item prop="searchTimeType">
              <template slot="label">
                <el-select
                  v-model="queryForm.params.timeType"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  :style="IsWidthTime"
                  class="selectClass"
                  size="small"
                >
                  <el-option
                    v-for="item in timeTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </template>
              <el-date-picker
                v-model="timeValue"
                :default-time="['00:00:00', '23:59:59']"
                :end-placeholder="$t('operationCenter.endDate')"
                :format="$i18n.locale === 'zh' ? zhDate : ptDate"
                :start-placeholder="$t('operationCenter.startDate')"
                range-separator="~"
                size="small"
                style="width: 100%"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--网点名称-->
            <el-form-item :label="$t('navbar.siteName')">
              <el-select
                v-model="queryForm.params.siteIdList"
                :placeholder="$t('GlobalSetObj.OnlyAreDisplayed')"
                clearable
                filterable
                multiple
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in siteList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 账号名称 -->
            <el-form-item :label="$t('customerManagements.AccountName')">
              <el-input
                v-model="queryForm.params.userName"
                :placeholder="$t('userManage.pleaseInput')"
                clearable
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 司机名称 -->
            <el-form-item :label="$t('collectionCenter.theDriverName')">
              <el-input
                v-model="queryForm.params.realName"
                :placeholder="$t('userManage.pleaseInput')"
                clearable
                size="small"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <!--派送车辆类型-->
            <el-form-item :label="$t('receivablePayable.deliveryVehicleType')">
              <el-select
                v-model="queryForm.params.deliveryVehicleTypeList"
                :placeholder="$t('GlobalSetObj.all')"
                clearable
                collapse-tags
                filterable
                multiple
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in deliveryVehicleTypeList"
                  :key="item.dictId"
                  :label="item.dictDescribe"
                  :value="item.dictName"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <!-- 进度 -->
            <el-form-item :label="$t('Resource.schedule')">
              <el-select
                v-model="queryForm.params.state"
                :placeholder="$t('GlobalSetObj.all')"
                clearable
                filterable
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in progressList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <!-- 处理结果 -->
            <el-form-item :label="$t('collectionCenter.processingResult')">
              <el-select
                v-model="queryForm.params.handleResultList"
                :placeholder="$t('GlobalSetObj.all')"
                clearable
                collapse-tags
                multiple
                size="small"
                style="width: 100%"
              >
                <el-option key="1" :label="$t('seller.resubmit')" :value="1" />
                <el-option key="2" :label="$t('seller.rejectRegistration')" :value="2" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <div style="margin-top: 30px">
              <!--搜索-->
              <el-button
                size="small" type="primary" @click="enterGetSearch"
              >{{ $t('newOrder.search') }}
              </el-button>
              <!--重置-->
              <el-button
                size="small" style="margin-left: 20px" type="info"
                @click="resetData"
              >{{ $t('newOrder.reset') }}
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card>
      <div style="margin-bottom: 10px">
        <el-button
          size="small" type="primary" @click="newCode"
        >{{ $t('seller.addInvitationCode') }}
        </el-button>
      </div>
      <el-table
        :data="tableData"
        :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
        border
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column
          :label="$t('GlobalSetObj.serial')" align="center" type="index"
          width="80"
        />
        <el-table-column
          v-for="item in tableHeaderList"
          :key="item.id"
          :align="item.center"
          :label="item.label"
          :min-width="item.cloWidth"
          :prop="item.prop"
          :show-overflow-tooltip="false"
        >
          <template slot-scope="scope">
            <div v-if="item.prop === 'orderNumber'">
              {{ scope.row.orderNumber }}
            </div>
            <div v-else-if="item.prop === 'paymentVoucher'">
              <div v-if="scope.row[item.prop] === 1" style="color: #00A551">
                {{ $t('customerManagements.approved') }}
              </div>
              <div v-else-if="scope.row[item.prop] === 2" style="color: #f00">
                {{ $t('orderCenterCont.ReviewFailed') }}
              </div>
            </div>
            <div v-else-if="item.prop === 'code'">
              <div style="color: #00A551">
                {{ scope.row.code }}
              </div>
            </div>
            <div v-else>{{ scope.row[item.prop] ? `${scope.row[item.prop]}` : '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('newOrder.operation')" align="center" fixed="right"
          width="100"
        >
          <template slot-scope="scope">
            <div style="display: flex; justify-content: space-around; align-items: center">
              <el-tooltip
                v-if="scope.row.state === 4"
                :content="$t('seller.process')"
                class="item"
                effect="dark"
                placement="top"
              >
                <i class="iconfont icon-a-zu129 textOperator" @click="toHandle(scope.row)" />
              </el-tooltip>
              <el-tooltip
                :content="$t('GlobalSetObj.details')"
                class="item"
                effect="dark"
                placement="top"
              >
                <i class="iconfont icon-chakan textOperator" @click="toDetail(scope.row)" />
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page.sync="queryForm.pageNumber"
        :page-size.sync="queryForm.pageSize"
        :page-sizes="[10, 50, 100, 200, 400]"
        :total="queryForm.total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: 20px 0; text-align: right"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>
    <!--  生成邀请码  -->
    <newCodeDrawer
      ref="newCodeDialogRef"
      :delivery-vehicle-type-list="deliveryVehicleTypeList"
      :site-list="siteList"
      @invoke-search="enterGetSearch"
    />
    <!--  处理  -->
    <handleDialog ref="handleDialogRef" :row-obj="rowObj" @invoke-search="enterGetSearch" />
    <!-- 详情 -->
    <detailCode :key="rowObj.id" ref="detailDialogRef" @invoke-search="enterGetSearch" />
  </div>
</template>

<script>
import { headerList } from './tableHeadListData/index';
import dayjs from 'dayjs';
import {
  deliveryRegisterPageQuery,
  getDeliveryVehicle,
  getDispatchSite
} from '@/api/newExpressAPI/userModule';
import newCodeDrawer from './component/newCode.vue';
import handleDialog from './component/handle.vue';
import detailCode from './component/detailCode.vue';
import { progressListObj, resultObj } from '@/utils/enumData';
import { seller } from '@/lang/type/newSeller';

export default {
  name: 'LargeOrderManagement',
  components: {
    newCodeDrawer,
    handleDialog,
    detailCode
  },
  data() {
    return {
      waybillList: '',
      trajectoryUrl: '/static/track.png',
      // 是否格式化成巴西时间
      zhDate: 'yyyy-MM-dd HH:mm:ss',
      ptDate: 'dd-MM-yyyy HH:mm:ss',
      isTormat: false,
      timeValue: [],
      tableHeaderList: headerList,
      tableData: [],
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        params: {
          timeType: 1, // 时间类型 1 失效时间 2 资料提交审核时间 3 最新处理时间
          startTime: '', // 开始时间
          endTime: '', // 结束时间
          siteIdList: [], // 网点id
          userName: '', // 账号名称(用户名称与账号名称改成输入框)
          realName: '', // 司机名称
          deliveryVehicleTypeList: [], // 派送车辆类型
          state: null, // 进度 1-6,看需求从上到下
          handleResultList: [] // 处理结果 1重新提交 2拒绝注册 可多选
        }
      },
      // 勾选表格数据
      selectionList: [],
      siteList: [],
      DetailId: 0,
      detailDialog: false,
      detailDialogObj: {},
      keyChange: '',
      timeTypeList: [
        { value: 1, label: this.$t('Resource.CreationTime') },
        { value: 2, label: this.$t('seller.expirationTime') },
        { value: 3, label: this.$t('seller.documentReviewTime') },
        { value: 4, label: this.$t('GlobalSetObj.LatestProcessingTime') }
      ],
      deliveryVehicleTypeList: [],
      progressList: [
        { id: 1, label: this.$t('compensationManagement.ToBeSubmitted') },
        { id: 2, label: this.$t('Resource.underReview') },
        { id: 3, label: this.$t('customerManagements.approved') },
        { id: 4, label: this.$t('home.unapplivefail') },
        { id: 5, label: this.$t('GlobalSetObj.Rejected') },
        { id: 6, label: this.$t('seller.expired') }
      ],
      rowObj: {}
    };
  },
  computed: {
    seller() {
      return seller;
    },
    IsWidthTime() {
      return {
        width: this.isTormat ? '200px' : '150px'
      };
    }
  },
  mounted() {
    if (this.$i18n.locale !== 'zh') {
      this.isTormat = true;
    }
    this.getTimer();
    this.getSearch();
    this.getSiteList();
    this.getDeliveryVehicleList();
  },
  methods: {
    // 处理
    toHandle(row) {
      console.log(row, '处理');
      this.rowObj = row;
      this.$refs.handleDialogRef.openHandleDialog(this.rowObj);
    },
    // 查看详情
    toDetail(row) {
      console.log(row, '查看详情');
      this.rowObj = row;
      this.$nextTick(() => {
        this.$refs.detailDialogRef.openDetailDialog(this.rowObj);
      });
    },
    // 点击生成邀请码
    newCode() {
      this.$refs.newCodeDialogRef.openCodeDialog();
    },
    // 勾选
    handleSelectionChange(data) {
      this.selectionList = data;
    },
    // 搜索
    getSearch() {
      const data = {
        pageNumber: this.queryForm.pageNumber,
        pageSize: this.queryForm.pageSize,
        params: {}
      };
      data.params = this.queryForm.params;
      if (this.timeValue && this.timeValue.length > 0) {
        data.params.startTime = this.timeValue[0];
        data.params.endTime = this.timeValue[1];
      } else {
        if (!this.queryForm.params.searchNumberStr) {
          this.$message.warning(this.$t('collectionCenter.PleaseSelectTime'));
          return;
        }
      }
      deliveryRegisterPageQuery(data).then((res) => {
        if (res.code === 200) {
          this.queryForm.total = res.data.total;
          this.tableData = res.data.records;
          this.tableData.forEach((item) => {
            if (item.state) {
              item.progressName = progressListObj[item.state];
            }
            if (item.handleResult) {
              item.handleResultName = resultObj[item.handleResult];
            }
          });
        }
      });
    },
    // 获取客户选项
    getSiteList() {
      getDispatchSite().then((res) => {
        if (res.code === 200) {
          this.siteList = res.data;
        }
      });
    },
    // 获取客户选项
    getDeliveryVehicleList() {
      getDeliveryVehicle().then((res) => {
        if (res.code === 200) {
          this.deliveryVehicleTypeList = res.data;
        }
      });
    },
    // 分页
    handleSizeChange(val) {
      this.queryForm.pageNumber = 1;
      this.queryForm.pageSize = val;
      this.getSearch();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.getSearch();
    },
    // 获取最近一星期时间
    getTimer() {
      const today = dayjs().format('YYYY-MM-DD');
      const beforTime = dayjs().subtract(1, 'week').format('YYYY-MM-DD');
      this.timeValue = [beforTime + ' 00:00:00', today + ' 23:59:59'];
    },
    resetData() {
      this.getTimer();
      this.queryForm = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          timeType: 1, // 时间类型 1 失效时间 2 资料提交审核时间 3 最新处理时间
          startTime: '', // 开始时间
          endTime: '', // 结束时间
          siteIdList: [], // 网点id
          userName: '', // 账号名称(用户名称与账号名称改成输入框)
          realName: '', // 司机名称
          deliveryVehicleTypeList: [], // 派送车辆类型
          state: null, // 进度 1-6,看需求从上到下
          handleResultList: [] // 处理结果 1重新提交 2拒绝注册 可多选
        }
      };
      this.getSearch();
    },
    enterGetSearch() {
      this.queryForm.pageNumber = 1;
      this.getSearch();
    }
  }
};
</script>

<style scoped>
.container {
  padding: 10px;
}

.searchBox >>> .selectClass .el-input__inner {
  font-weight: 700 !important;
}

.textOperator {
  font-size: 20px;
  color: #00A551;
  cursor: pointer;
}
</style>
